(function (angular, Qs) {
  "use strict";

  angular.module("Toyota.Services").service("UrlParser", function () {
    var api = {};
    var qs = Qs;

    // n.b. queryString always excludes question mark, search always includes it

    api.parse = function (url) {
      var parser = document.createElement("a");
      parser.href = url;
      return {
        protocol: parser.protocol, // => "http:"
        hostname: parser.hostname, // => "example.com"
        port: parser.port, // => "3000"
        pathname: parser.pathname, // => "/pathname/"
        search: parser.search, // => "?search=test"
        hash: parser.hash, // => "#hash"
        host: parser.host, // => "example.com:3000"
      };
    };

    api.queryStringToMap = function (queryString) {
      return qs.parse(queryString);
    };

    api.queryStringToMapFromUrl = function (url) {
      var qs = api.parse(url).search;
      return qs ? api.queryStringToMap(api.parse(url).search.split("?")[1]) : {};
    };

    api.mapToQueryString = function (map) {
      return qs.stringify(map);
    };

    api.replaceUrlQueryStringFromMap = function (url, map) {
      var parsed = api.parse(url);
      var queryString = api.mapToQueryString(map);
      var search = queryString ? "?" + queryString : "";
      return parsed.protocol + "//" + api.appendUrlHostWithPath(parsed.host, parsed.pathname) + search + parsed.hash;
    };

    api.overrideUrlQueryStringFromMap = function (url, overrideMap) {
      var replacementMap = angular.extend({}, api.queryStringToMapFromUrl(url), overrideMap);
      return api.replaceUrlQueryStringFromMap(url, replacementMap);
    };

    api.appendUrlHostWithPath = function (host, path) {
      var pathNormalised = path;

      if (host[host.length - 1] !== "\\" && host[host.length - 1] !== "/" && path[0] !== "\\" && path[0] !== "/") {
        pathNormalised = "/" + path;
      }

      return host + pathNormalised;
    };

    return api;
  });
})(window.angular, window.Qs);
